import { useMemo, useState } from 'react';
import { entries } from '@/mocks/home';

const tabs = [
  { key: 'all', label: '全部入口' },
  { key: '官网', label: '官网' },
  { key: '备用', label: '备用域名' },
];

export default function EntryIndex() {
  const [tab, setTab] = useState('all');
  const [copiedId, setCopiedId] = useState<string | null>(null);

  const list = useMemo(
    () => (tab === 'all' ? entries : entries.filter((e) => e.type === tab)),
    [tab],
  );

  const handleCopy = async (id: string, domain: string) => {
    try {
      await navigator.clipboard.writeText(domain);
    } catch {
      /* 忽略复制异常 */
    }
    setCopiedId(id);
    window.setTimeout(() => setCopiedId(null), 1600);
  };

  return (
    <section id="entry" className="border-b border-background-200 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="h-5 w-1 rounded-full bg-accent-500" />
              <span className="font-label text-sm tracking-[0.2em] text-accent-600">ENTRY INDEX</span>
            </div>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">入口合集 · 全线路索引</h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              按状态标注的入口总表，绿色「可用」优先选择。网址打不开时，来这里换一条备用域名通常最快。
            </p>
          </div>
          <div className="inline-flex self-start rounded-full border border-background-300 bg-background-100 p-1">
            {tabs.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => setTab(t.key)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                  tab === t.key ? 'bg-foreground-950 text-background-50' : 'text-foreground-600 hover:text-foreground-950'
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((e) => {
            const available = e.status === '可用';
            return (
              <article
                key={e.id}
                className="group flex flex-col rounded-lg border border-background-200 bg-background-100/60 p-4 transition-colors hover:border-primary-300 md:p-5"
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="flex items-center gap-2">
                    <span
                      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[12px] ${
                        available ? 'bg-primary-100 text-primary-900' : 'bg-secondary-100 text-secondary-900'
                      }`}
                    >
                      <span className={`h-1.5 w-1.5 rounded-full ${available ? 'bg-primary-500' : 'bg-secondary-500'}`} />
                      {e.status}
                    </span>
                    <span className="rounded-full bg-background-200 px-2.5 py-1 text-[12px] text-foreground-700">{e.type}</span>
                  </div>
                  <span className="text-[12px] text-foreground-500">{e.load}</span>
                </div>

                <h3 className="mt-4 font-heading text-lg text-foreground-950">{e.name}</h3>
                <p className="mt-1.5 flex items-center gap-1.5 text-sm text-foreground-700">
                  <i className="ri-global-line text-primary-600" />
                  <span className="truncate">{e.domain}</span>
                </p>
                <p className="mt-2 flex-1 text-[13px] leading-relaxed text-foreground-600">{e.note}</p>

                <div className="mt-4 flex items-center gap-2">
                  <button
                    type="button"
                    onClick={() => handleCopy(e.id, e.domain)}
                    className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3 py-2 text-[13px] text-foreground-800 transition-colors hover:bg-background-50"
                  >
                    <i className={copiedId === e.id ? 'ri-check-line text-primary-600' : 'ri-file-copy-line'} />
                    {copiedId === e.id ? '已复制' : '复制'}
                  </button>
                  <button
                    type="button"
                    className={`inline-flex flex-1 items-center justify-center gap-1.5 whitespace-nowrap rounded-md px-3 py-2 text-[13px] font-medium transition-colors ${
                      available
                        ? 'bg-foreground-950 text-background-50 hover:bg-foreground-900'
                        : 'bg-background-200 text-foreground-500'
                    }`}
                  >
                    {available ? '前往访问' : '暂不可用'}
                    <i className="ri-arrow-right-up-line" />
                  </button>
                </div>
              </article>
            );
          })}
        </div>

        <p className="mt-6 flex items-center gap-2 text-[13px] text-foreground-500">
          <i className="ri-information-line" />
          入口状态为定时巡检结果，仅作访问参考，点击后在新窗口打开。
        </p>
      </div>
    </section>
  );
}